<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container">
    <div class="header">
      <p> {{ t('userID') }}{{ userID }}</p>
    </div>
    <template  v-if="!isCall">
      <h3 style="text-align: center;font-weight: bold;">{{ t('title') }}</h3>
      <el-empty :description="t('waitingCall')" :image-size="250" :image="require('../assets/call.gif')"> </el-empty>

      <!-- <div style="width: 100%;height: 200px;background-color: #f5f5f5;z-index: 999" v-loading="true" :element-loading-text="t('waitingCall')"></div> -->
      <el-button style="display: block;margin: 0 auto;position: relative;z-index: 1000;" @click="callqucik">{{ t('hurryUp') }}</el-button>
    </template>
    <template v-else>
      <div class="btnList">
        <p style="font-size: 12px;line-height: 20px;">{{ t('subSwitch') }}</p>
        <el-switch v-model="isAction" @change="bScrollBottom()"  size="small" style="--el-switch-on-color: #13ce66" />
      </div>
   </template>
    <div class="languageShow"  v-if="translatArr.length">
      <p>{{ t(`langSwitch.${callLan}`) }}</p>
      <div style="width: 100px;"></div>
      <p >{{t(`langSwitch.${pickLan}`) }}</p>
    </div>

    <div class="translatList">
      <div class="scroll-wrapper">
        <div class="scroll-content" v-if="isAction" >
        <div v-for="item in translatArr" :key="item" class="scroll-item" :class="item.speakUser === userID ? 'fr' : ''">
          <div class="translatCont" v-if="item.speakUser === userID">
            <p> {{ item.fText }}</p>
            <p> {{ item.tText }}</p>
          </div>
          <div class="translatCont" v-else>
            <p> {{ item.tText }}</p>
            <p> {{ item.fText }}</p>
          </div>
        </div>
      </div>
      </div>
    </div>
    <!-- <el-button @click="getDevices">getDevices</el-button> -->

    <!-- <ul class="deviceList">
      <li><h4>选择播放设备：</h4></li>
      <li v-for="item in micphoneList" :key="item.deviceId">
        <el-button size='small' @click="chooseMic(item)">{{ item.label }}</el-button>
      </li>
    </ul> -->
  </div>

</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { TUICallKitServer } from '@tencentcloud/call-uikit-vue'
import { TUICallEvent } from 'tuicall-engine-webrtc'
// import * as GenerateTestUserSig from '../debug/GenerateTestUserSig-es' // 确保路径正确
import TRTC from 'trtc-sdk-v5'
import { useI18n } from 'vue-i18n'
import axios from 'axios'
import { ElMessage, ElLoading, ElNotification } from 'element-plus'
import { useRoute, useRouter } from 'vue-router'
import md5 from 'js-md5'
import BScroll from '@better-scroll/core'
// import VConsole from 'vconsole/dist/vconsole.min.js'

export default {
  setup () {
    // 多语言设置
    const { t } = useI18n()
    const isCall = ref(false)
    const isAction = ref(true)
    const translatArr = ref([])
    const route = useRoute()
    const router = useRouter()
    const userID = route.query.userid
    const callLan = route.query.call
    const pickLan = route.query.pick
    const sdkAppId = 1600062488 // 替换为你的实际 SDKAppID
    const micphoneList = ref([])
    const isH5 = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    let bScroll = null// BetterScroll 实例
    const svg = '<svg t="1733798591575" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="5473" width="48" height="48"><path d="M215.62174 810.964648a425.984 425.984 0 1 0 602.421836-602.442864 425.984 425.984 0 1 0-602.421836 602.442864Z" fill="#00A0E9" p-id="5474"></path><path d="M646.8096 728.5248c-53.9648-2.4576-91.5456-16.5888-126.8736-36.6592-82.0224-46.4896-144.8448-111.616-186.4704-196.4544-15.3088-31.232-25.344-64.256-25.7024-99.4304-0.256-31.2832 8.1408-59.5968 31.488-81.9712 6.8096-6.5024 13.2096-13.4656 20.2752-19.6096 10.6496-9.2672 24.6272-9.472 35.9424-1.0752 2.5088 1.8432 4.8128 3.9936 7.0144 6.2464 28.3648 28.3136 56.7296 56.6272 85.0432 84.992 15.2576 15.2576 15.104 32.3584-0.3072 47.616l-15.5136 15.2064c-5.376 5.2736-7.168 11.776-6.3488 19.1488 2.2528 20.5312 12.6464 37.3248 25.1392 52.8384 15.7696 19.5584 34.56 35.84 58.0608 45.568 7.2192 3.0208 15.2576 5.376 22.9888 5.4784 5.632 0.1024 12.0832-2.9696 16.7936-6.4512 6.3488-4.6592 11.2128-11.264 16.9472-16.7936 13.824-13.4144 31.3344-13.4144 45.0048 0.256 29.0816 28.9792 58.0608 58.0096 86.9888 87.0912 14.9504 15.0528 15.0016 31.2832 0.3072 46.336-4.7104 4.864-9.6768 9.4208-14.2848 14.3872-24.1664 25.9072-54.9888 33.9456-76.4928 33.28z" fill="#FFFFFF" p-id="5475"></path></svg>'
    // const vConsole = new VConsole()

    // 设置ui语言
    const setUiLang = () => {
      const val = pickLan || 'en'
      console.log('tuiLang, tuiLang, val', pickLan)
      let tuiLang = 'en'
      if (val === 'zh') {
        tuiLang = 'zh-cn'
      } else if (val === 'ja') {
        tuiLang = 'ja_JP'
      } else {
        tuiLang = 'en'
      }
      console.log('tuiLang, tuiLang, val', tuiLang, val)
      TUICallKitServer.setLanguage(tuiLang)
    }
    // 本地获取userSig
    // const localGetSig = () => {
    //   const SecretKey = 'a5759ef4014f1cc84c0975f15ae89efda1e74d985d2563a9cf54442be7a06271' // 替换为你的实际 SecretKey（仅用于测试）
    //   const localSig = GenerateTestUserSig.genTestUserSig({
    //     userID,
    //     SDKAppID: sdkAppId,
    //     SecretKey
    //   })
    //   return localSig.userSig
    // }
    // 初始化 TUICallKit

    const initCallKit = async (userSig) => {
      try {
        console.log('开始初始化 TUICallKit...')
        // 初始化 TUICallKitServer
        await TUICallKitServer.init({
          userID: userID, // 替换为实际用户 ID
          userSig,
          SDKAppID: sdkAppId
        })
        loading.close()
        // 各种提醒
        ElMessage({
          message: t('initSuccess'),
          type: 'success'
        })
        ElNotification({
          title: t('careful'),
          message: t('wait'),
          duration: 5000
        })
        // 监听ai机器人
        listenAI()
        getDevices()
        console.log('TUICallKit 初始化成功')
        const tuiCallEngine = TUICallKitServer.getTUICallEngineInstance()
        // 新的来电请求事件。35
        tuiCallEngine.on(TUICallEvent.ON_CALL_RECEIVED, () => {
          isCall.value = true
          if (micphoneList.value.length) {
            chooseMic(micphoneList.value[0])
          }
        })
        tuiCallEngine.on(TUICallEvent.ON_CALL_CANCELED, () => {
          isCall.value = false
        })
        // 监听通话开始事件
        tuiCallEngine.on(TUICallEvent.ON_CALL_BEGIN, () => {
          ElMessage({
            message: t('callStart'),
            type: 'success'
          })
        })
        // 监听对方退房事件
        tuiCallEngine.on(TUICallEvent.USER_LEAVE, (event) => {
          TUICallKitServer.getTUICallEngineInstance().hangup().then(hangUp(event.userID)).catch(error => {
            console.warn('hangup error:', error)
          })
        })
        // 监听通话结束事件
        tuiCallEngine.on(TUICallEvent.CALLING_END, () => {
          translatArr.value = []
          isCall.value = false
        })
      } catch (error) {
        console.error('初始化失败:', error)
        alert('初始化失败，请检查日志')
      }
    }
    // 获取麦克风设备列表
    const getDevices = () => {
      // const trtc = TUICallKitServer.getTUICallEngineInstance().getTRTCCloudInstance()._trtc
      const tuiCallEngine = TUICallKitServer.getTUICallEngineInstance()
      tuiCallEngine.getDeviceList('microphone') // 请求权限，传入 true
        .then(devices => {
          console.log('麦克风设备列表:', devices)
          const filtered = devices.reduce((acc, device) => {
            if (!acc.some(d => d.groupId === device.groupId)) {
              acc.push(device)
            }
            return acc
          }, [])
          if (filtered.length > 1) {
            // 麦克风设备大于1时
            micphoneList.value = filtered.filter(device => {
              const lowerLabel = device.label.toLowerCase()
              return !lowerLabel.includes('麦克风') && !lowerLabel.includes('phone')
            })
          }
          console.log('列表', micphoneList.value)
          // 在这里处理扬声器列表
        })
        .catch(error => {
          console.error('获取麦克风设备失败:', error)
        })
    }
    const chooseMic = (device) => {
      const ua = navigator.userAgent.toLowerCase()
      if (/iphone|ipad|ipod/.test(ua)) {
        console.log('选择麦克风', device.deviceId)
        const tuiCallEngine = TUICallKitServer.getTUICallEngineInstance()
        // 切换设备
        tuiCallEngine.switchDevice({ deviceType: 'microphone', deviceId: device.deviceId })
          .then(() => {
            ElMessage.info({ message: 'choose:' + device.label })
          // 在这里处理扬声器列表
          })
          .catch(error => {
            console.error('获取麦克风设备失败:', error)
          })
      } else {
        console.log('not ios')
      }
      // ElMessage.info({ message: 'choose:' + device.label })
    }

    // 监听AI机器人消息
    const listenAI = () => {
      try {
        const trtc = TUICallKitServer.getTUICallEngineInstance().getTRTCCloudInstance()._trtc
        // 绑定自定义消息事件
        trtc.on(TRTC.EVENT.CUSTOM_MESSAGE, async (event) => {
          try {
            const getData = new TextDecoder().decode(event.data)
            // console.log('接收到的原始数据:', getData)
            const jsonData = JSON.parse(getData)
            // console.log('解析后的 JSON 数据:', jsonData)
            if (jsonData.payload?.end) {
              const getTdata = jsonData.payload
              const translatInfo = {
                fText: getTdata.text,
                tText: getTdata.translation_text,
                speakUser: jsonData.sender
              }
              // translatArr.value.unshift(translatInfo)
              translatArr.value.push(translatInfo)
              // 字幕滚动
              nextTick(() => {
                bScrollBottom()
              })
              // console.log(
              //   '字幕内容:',
              //   jsonData.payload.text,
              //   '翻译:',
              //   jsonData.payload.translation_text
              // )
            } else {
              console.warn('未找到字幕结束标志 (end)')
            }
          } catch (error) {
            console.error('处理自定义消息时出错:', error)
          }
        })

        console.log('自定义消息监听已绑定！')
      } catch (error) {
        console.error('初始化 TRTC 或绑定事件时出错:', error)
      }
    }
    const bScrollBottom = () => {
      bScroll.refresh()
      bScroll.scrollTo(0, bScroll.maxScrollY, 300)
    }
    // 等待初始化动画
    const loading = ElLoading.service({
      lock: true,
      text: t('initWait'),
      spinner: svg, // 使用自定义 SVG 组件
      background: '#f5f5f5'
    })

    // 对方挂断电话后
    const hangUp = (duserID) => {
      // success
      // console.log('对面的id:', duserID, '对面的id长度:', duserID.length)
      if (duserID.length === 7) {
        ElMessage.error(t('callEnd'))
        // 初始化状态
        translatArr.value = []
        isCall.value = false
      }
    }

    /* / 开关字幕 start--------------------
    const rebotTask = ref('')
    const rebotSig = GenerateTestUserSig.genTestUserSig({
      userID: 'rebot001',
      SDKAppID: sdkAppId,
      SecretKey
    })
    const startTranscription = async () => {
      const params = {
        SdkAppId: sdkAppId, // 替换为实际 SdkAppId
        RoomId: '8888', // 替换为实际 RoomId
        TranscriptionParams: {
          UserId: 'rebot001', // 替换为实际用户 ID
          UserSig: rebotSig.userSig, // 替换为实际用户签名
          TranscriptionMode: 1,
          TargetUserId: '1233'
        },
        RecognizeConfig: {
          Language: 'zh',
          TranslationLanguage: 'en'
        }
      }

      try {
        const response = await axios.post(
          'http://localhost:3000/start-ai-transcription',
          params
        )
        const getdata = response.data.TaskId
        console.log(getdata, typeof (getdata))
        rebotTask.value = getdata
      } catch (error) {
        console.error('Error:', error)
        rebotTask.value = 'Error occurred while processing.'
      }
    }
    const stopTranscription = async () => {
      const params = {
        TaskId: rebotTask.value
      }

      try {
        const response = await axios.post(
          'http://localhost:3000/stop-ai-transcription',
          params
        )
        rebotTask.value = JSON.stringify(response.data, null, 2)
      } catch (error) {
        console.error('Error:', error)
        rebotTask.value = 'Error occurred while processing.'
      }
    }

    开关字幕end------------------ */

    // 在组件挂载时初始化
    onMounted(() => {
      TRTC.isSupported().then((checkResult) => {
        console.log(checkResult)
        if (checkResult.result && checkResult.detail.isBrowserSupported) {
          if (route.query.userid && route.query.call && route.query.pick) {
            const parms = md5(userID).substring(2, 9)
            setUiLang()
            // SDK获取userSig
            axios.post(
              'https://auth.nebulabuds.com/api/getUserSgin/',
              { userCode: userID, pass: parms }
            ).then(res => {
              initCallKit(res.data.userSign)
            }).catch(err => {
              console.log('err', err)
              // const localSig = localGetSig()
              // initCallKit(localSig)
            })
            // 初始化点击事件
            bScroll = new BScroll('.scroll-wrapper', {
              scrollY: true, // 垂直滚动
              click: true // 支持点击事件
            })
          } else {
            router.replace('error')
            loading.close()
          }
        } else {
          ElMessage.error('Not Support')
          router.replace({ name: 'nosupport', query: { lang: pickLan } })
          loading.close()
        }
      })
    })

    // 注销
    onUnmounted(async () => {
      // TUICallKitServer.getTUICallEngineInstance().logout().then(
      //   TUICallKitServer.destroyed()
      // ).catch(error => {
      //   console.warn('logout error:', error)
      // })
      // 销毁案例
      if (bScroll) { bScroll.destroy() }
      if (TUICallKitServer) { TUICallKitServer.destroyed() }
    })

    // 催一下，其实没啥用
    const callqucik = () => {
      ElMessage({
        message: t('wait'),
        type: 'info'
      })
    }

    return {
      t,
      isCall,
      isAction,
      userID,
      translatArr,
      callLan,
      pickLan,
      callqucik,
      bScrollBottom,
      getDevices,
      isH5
    }
  }
}
</script>
<style scoped>
.header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 5px;
}

.header p {
  padding: 0 10px;
  font-size: 14px;
  color: orange;
}

.btnList {
  position: fixed;
  top: 10px;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 0 10px;
  background-color: rgba(255, 255, 255, .7);
  border: 1px solid #ccc;
  border-radius: 0 10px 10px 0;
}
.languageShow{
  position: fixed;
  padding: 10px;
  top: 5%;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  z-index: 999;
}
.languageShow p{
  min-width: 80px;height: 30px;background-color: #666;text-align: center;line-height: 30px;color: #fff;border-radius: 5px;
}
.translatList {
  position: fixed;
  top: calc(50% - 100px);
  left: calc(50% - 450px);
  z-index: 999;
  width: 900px;
  height: 240px;
}

.scroll-wrapper {
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.scroll-item {
  width: 96%;
  margin: 5px 2%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
}

.translatCont {
  padding: 3px 5px;
  background-color: rgba(60, 63, 75, .7);
  border-radius: 0 10px 10px 10px;
  max-width: 65%;
}

.translatCont p {
  line-height: 20px;
  padding: 5px;
  color: #fff
}

.translatCont p:nth-child(2) {
  font-size: 14px;
  border-top: 1px solid #B3B3B3;
  color: #B3B3B3;
}

.fr {
  justify-content: flex-end;
}

.fr .translatCont {
  background-color: rgba(45, 107, 228, .7);
  border-radius: 10px 10px 0 10px;
}

.deviceList {position: fixed;top: 70px;left: 0;z-index: 999;display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;  z-index: 999;
  padding: 5px;
  background-color: rgba(255, 255, 255, .7);
  border: 1px solid #ccc;
  border-radius: 0 10px 10px 0;}
.deviceList li{margin: 3px 0;}
.deviceList h4{font-size: 14px;color: orange;}
.deviceList button{max-width: 120px;overflow: hidden;}
@media (max-width: 1000px) {
  .languageShow{
    top: 0;
  }
  .translatList {
    position: fixed;
    top: 30%;
    left: 0;
    z-index: 999;
    width: 100%
  }

  .translatCont {
    padding: 2px;
  }
}
</style>
